import "./HeroSubtitle.css";

// --------------------------------------------------------------------------------------

export default function HeroSubtitle() {
	return (
		<p className="hero-subtitle">
			A companion calculator for{" "}
			<a href="TODO" target="_blank" rel="noopener noreferrer">
				The State of Brain Emulation Report 2025
			</a>{" "}
			written by{" "}
			<a
				className="unstyled-link"
				href="https://www.linkedin.com/in/mxschons"
				target="_blank"
				rel="noopener noreferrer"
			>
				Maximilian Schons
			</a>
			,{" "}
			<a
				className="unstyled-link"
				href="https://www.linkedin.com/in/niccol%C3%B2-zanichelli-99a7881a3"
				target="_blank"
				rel="noopener noreferrer"
			>
				Niccolò Zanichelli
			</a>
			, and{" "}
			<a
				className="unstyled-link"
				href="https://www.linkedin.com/in/freemanisaak"
				target="_blank"
				rel="noopener noreferrer"
			>
				Isaak Freeman
			</a>
			. Made possible by{" "}
			<a
				className="unstyled-link"
				href="https://press.asimov.com"
				target="_blank"
				rel="noopener noreferrer"
			>
				Asimov Press
			</a>
			.
		</p>
	);
}
